var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { debounce } from 'lodash';
import Carousel from '../../Carousel/Carousel';
import PhotoFrame from '../../Photo/PhotoFrame';
import ResizedPhoto from '../../Photo/ResizedPhoto';
import Warning from '../../../components/Warning';
import CarouselUploadPlaceholder from './CarouselUploadPlaceholder';
import { CarouselPlaceholder } from '../../../models/carousel-placeholder';
import { updateSelectedPhoto, updateSelectedProductItem } from '../store/actions';
var mapStateToProps = function (state) { return ({
    cartItem: state.cart.cartItems.item.item,
}); };
var mapDispatchToProps = {
    updateSelectedPhoto: updateSelectedPhoto,
    updateSelectedProductItem: updateSelectedProductItem,
};
var connector = connect(mapStateToProps, mapDispatchToProps);
var CarouselPhotoList = /** @class */ (function (_super) {
    __extends(CarouselPhotoList, _super);
    function CarouselPhotoList(props) {
        var _this = _super.call(this, props) || this;
        _this.wrapperElement = null;
        _this.resizeEventListener = null;
        _this.debouncedWrapperSizeUpdate = null;
        _this.isResizing = false;
        _this.state = {
            isResizing: false,
            wrapperWidth: null,
            wrapperHeight: null,
        };
        _this.handleWindowResize = _this.handleWindowResize.bind(_this);
        return _this;
    }
    CarouselPhotoList.prototype.componentDidMount = function () {
        var _this = this;
        window.addEventListener('resize', this.handleWindowResize);
        this.debouncedWrapperSizeUpdate = debounce(function () {
            _this.isResizing = false;
            _this.updateWrapperSizes();
        }, 500);
    };
    CarouselPhotoList.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.handleWindowResize);
    };
    CarouselPhotoList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: 'c-carousel-photo-list__wrapper' },
            React.createElement("div", { ref: function (element) { return _this.setWrapperElementRef(element); }, className: "c-carousel-photo-list" }, this.renderPhotos())));
    };
    CarouselPhotoList.prototype.renderPhotos = function () {
        var _this = this;
        var _a, _b;
        if (!Array.isArray(this.props.photos) || !this.props.photos.length) {
            return null;
        }
        if (!this.state.wrapperWidth || !this.state.wrapperHeight) {
            return null;
        }
        var items = __spreadArray([], this.props.photos);
        return (React.createElement(Carousel, { onChange: function (item) { return _this.updateSelected(item); }, items: items, renderItem: function (item) { return _this.renderItem(item); }, activeItemId: (_b = (_a = this.props.selectedPhoto) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : -1, enableController: true }));
    };
    CarouselPhotoList.prototype.renderItem = function (item) {
        if (item instanceof CarouselPlaceholder) {
            return React.createElement(CarouselUploadPlaceholder, { key: item.id, photosCount: this.props.photos.length, cartItem: this.props.cartItem });
        }
        var dpi = item.getDpi();
        return (React.createElement("div", { key: item.id, className: "c-carousel-photo-list__item" },
            React.createElement(PhotoFrame, { photo: item, crop: true },
                React.createElement(ResizedPhoto, { photo: item })),
            dpi && dpi < 150 && (React.createElement("div", { className: "c-carousel-photo-list__item__warning" },
                React.createElement(Warning, { title: "warnings.low_image_quality.title" })))));
    };
    CarouselPhotoList.prototype.handleWindowResize = function () {
        if (!this.isResizing) {
            this.isResizing = true;
            this.setState({ isResizing: true });
        }
        if (this.debouncedWrapperSizeUpdate) {
            this.debouncedWrapperSizeUpdate();
        }
    };
    CarouselPhotoList.prototype.setWrapperElementRef = function (element) {
        if (this.wrapperElement) {
            return;
        }
        this.wrapperElement = element;
        this.updateWrapperSizes();
    };
    CarouselPhotoList.prototype.updateWrapperSizes = function () {
        if (!this.wrapperElement) {
            return;
        }
        var wrapperWidth = this.wrapperElement.clientWidth;
        var wrapperHeight = this.wrapperElement.clientHeight;
        if (wrapperWidth === this.state.wrapperWidth && wrapperHeight === this.state.wrapperHeight) {
            return;
        }
        this.setState({ wrapperWidth: wrapperWidth, wrapperHeight: wrapperHeight, isResizing: false });
    };
    CarouselPhotoList.prototype.updateSelected = function (item) {
        var _a;
        var selectedPhoto = item && item.id > 0 ? item : null;
        this.props.updateSelectedPhoto(selectedPhoto);
        this.props.updateSelectedProductItem((_a = selectedPhoto === null || selectedPhoto === void 0 ? void 0 : selectedPhoto.product_item) !== null && _a !== void 0 ? _a : null);
    };
    return CarouselPhotoList;
}(React.Component));
export default connector(withTranslation()(CarouselPhotoList));
